import { Pipe, PipeTransform } from '@angular/core';
import { Category } from '@interfaces/Category';

@Pipe({
  name: 'categoryExpenseBillableFinal'
})
export class CategoryExpenseBillableFinalPipe implements PipeTransform {
  public transform(category: Category): number {
    let total = 0;
    let subtotal1 = 0;
    let subtotal2 = 0;

    for (const line of category.estimateLines) {
      if (line.expenseLine) {
        if (line.expenseLine.billableFinal === null) {
          subtotal1 += line.expenseLine.amountBillable;
        } else {
          subtotal2 += line.expenseLine.billableFinal;
        }
        total = subtotal1 + subtotal2;
      }
    }

    return total;
  }
}
